(function() {
    'use strict';

    angular.module('dashboardApp').service('Apps', Service);

    Service.$inject = [
        'AppSettings',
        'RequestWrapper'
    ];


    function Service(
        AppSettings,
        RequestWrapper
    ) {



        this.list = function() {
            var request = {
                url: AppSettings.paths.api + 'Application/List'
            };

            return RequestWrapper.send(request);
        };


    }

})();
